// extracted by mini-css-extract-plugin
module.exports = {"caretIcon":"LinksMenu-module_caretIcon__jDFVyLBQsNqkrPsfYVC5","customIcon":"LinksMenu-module_customIcon__UltWMr2IOr40wsxo7Nmk"};